// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.RentCreditReportOptInHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { RentCreditReportOptInWebApiRequestDto } from '../..';

export const RentCreditReportOptInHandler_optIn_Path = '/api/web/v1/rentCreditReport/optIn';

/**
 * Opt in to rent reporting
 */
export const RentCreditReportOptInHandler_optIn = (
  postData: RentCreditReportOptInWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, RentCreditReportOptInWebApiRequestDto, void>(
    {
      endpoint: RentCreditReportOptInHandler_optIn_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
